import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { resolvePostLoginDestination } from '../auth/postLoginRouting';
import { API_BASE_URL } from '../config/apiBase';
import 'bootstrap/dist/css/bootstrap.min.css';
import bakeonatorLogo from '../assets/images/logos/bakeonator_logo.png';
import { ensureCsrfToken } from '../services/csrf';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const API_URL = API_BASE_URL;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const { setIsAuthenticated, refreshSession } = useAuth();

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      // Always refresh CSRF before login — stale/truncated cookies cause 403
      // "incorrect length" failures against Django.
      const csrfToken = await ensureCsrfToken({ forceRefresh: true });
      const res = await fetch(`${API_URL}/login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      if (res.ok) {
        const session = await refreshSession();
        if (!session || !session.isauthenticated) {
          throw new Error('Session bootstrap failed');
        }
        setIsAuthenticated(true);
        setEmail('');
        setPassword('');
        setError('');
        const destination = resolvePostLoginDestination(session, { returnTo });
        navigate(destination, { replace: true });
      } else {
        throw new Error('Login failed');
      }
    } catch (err) {
      console.error(err);
      setError('No active account found with the given credentials.');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body text-center">
              <img
                src={bakeonatorLogo}
                alt="Bakeonator Logo"
                width="auto"
                height="100"
                className="mx-auto d-block mb-3"
              />
              <h2 className="card-title text-center mb-4">Sign In</h2>
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3 text-end">
                  <Link to="/forgot-password" className="small">
                    Forgot password?
                  </Link>
                </div>
                <div className="d-grid">
                  <button type="submit" className="btn btn-primary">
                    Login
                  </button>
                </div>
              </form>
              {error && <div className="alert alert-danger mt-4">{error}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
